import Component from './Component';
import normalizeNode from './normalizeNode';
import { serialize } from './serialize';
import { isJsxCommentToken, type } from './shared';

const JsxCommentToken = {
  Component,
  hasInlineMd: true,
  is: isJsxCommentToken,
  isInline: true,
  isJsxCommentToken,
  normalizeNode,
  serialize,
  type,
};

export default JsxCommentToken;
